import React from "react";

export const Logo = ({ className = "", variant = "dark", showTagline = false }) => {
  const light = variant === "light";
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <div className="relative grid place-items-center h-10 w-10 rounded-xl bg-brand text-white shadow-md">
        <span className="font-extrabold text-lg leading-none tracking-tight">IP</span>
        <span className="absolute -top-1 -right-1 h-3 w-3 rounded-full bg-gold border-2 border-white" />
      </div>
      <div className="leading-tight">
        <div className={`font-extrabold tracking-tight text-lg ${light ? "text-white" : "text-brand"}`}>
          Instant<span className="text-gold">Paisa</span>
        </div>
        {showTagline && (
          <div className={`text-[10px] font-semibold uppercase tracking-[0.2em] ${light ? "text-white/70" : "text-muted-foreground"}`}>
            Fast. Simple. Transparent.
          </div>
        )}
      </div>
    </div>
  );
};
